import Vue from "vue";

Vue.prototype.$prod_details = [
  {
    key: "contraff",
    select: [
      {
        key: "tipocontr",
        option: [
          { key: "tipocontr1" },
          { key: "tipocontr2" },
          { key: "tipocontr3" },
          { key: "tipocontr4" },
          { key: "tipocontr5" },
          { key: "tipocontr6" },
          { key: "tipocontr7" },
          { key: "tipocontr8" },
          { key: "tipocontr9" },
          { key: "tipocontr10" }
        ]
      }
    ]
  },
  {
    key: "sottopiede",
    select: [
      {
        key: "matsotto",
        option: [{ key: "cuoi" }, { key: "tex" }, { key: "sint" }]
      },
      {
        key: "rinfsotto",
        option: [
          { key: "rinfdotto1" },
          { key: "rinfdotto2" },
          { key: "rinfdotto3" },
          { key: "rinfdotto4" },
          { key: "rinfdotto5" },
          { key: "rinfdotto6" },
          { key: "rinfdotto7" },
          { key: "rinfdotto8" }
        ]
      }
    ]
  },
  {
    key: "puntali",
    select: [
      {
        key: "tipopunt",
        option: [
          { key: "tipopunt1" },
          { key: "tipopunt2" },
          { key: "tipopunt3" },
          { key: "tipopunt4" },
          { key: "tipopunt5" },
          { key: "tipopunt6" },
          { key: "tipopunt7" }
        ]
      }
    ]
  },
  {
    key: "sol_vant",
    select: [
      {
        key: "sol_vant_alias",
        option: [{ key: "taccsol_vant" }, { key: "piant" }]
      }
    ]
  }
];
